import { PREFIX } from "../config";
import cx from 'classnames';
export var useStyleOverrides = function (props, name) {
    var className = "".concat(PREFIX, "-").concat(name);
    return {
        style: props.style,
        className: cx(className, props.className),
    };
};
